// External Imports
import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

// Internal Imports
import { getEdition } from './getEdition.js';

// Local Functions
const createGetTranslation = createSelector(
  [getEdition, get('translations')],
  (edition, translations) => (field, defaultText) =>
    get(`${field}.${edition}`, translations) || defaultText,
);

// Module Exports
export { createGetTranslation };
